import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'
import Collapse from '@mui/material/Collapse'
import BlockIcon from '@mui/icons-material/Block'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { FC, useCQuery, invalidateQuery } from '../../Services'

const BlacklistSection = () => {
  const { data: blacklistRaw = [], isSuccess } = useCQuery('blacklist')
  const blacklist = Array.isArray(blacklistRaw) ? blacklistRaw : blacklistRaw?.data || []
  const [input, setInput] = useState('')
  const [expanded, setExpanded] = useState(true)

  const handleAdd = async () => {
    const fileName = input.trim()
    if (!fileName) return

    try {
      await FC.service('blacklist').create({ fileName })
      invalidateQuery('blacklist')
      setInput('')
    } catch (error) {
      const msg = error?.message || 'Errore durante l\'aggiunta alla blacklist.'
      window.growl.show({ severity: 'error', summary: 'Errore', detail: msg })
    }
  }

  const handleRemove = async (id) => {
    try {
      await FC.service('blacklist').remove(id)
      invalidateQuery('blacklist')
    } catch (error) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore durante la rimozione dalla blacklist.' })
    }
  }

  if (!isSuccess) return null

  return (
    <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ cursor: 'pointer' }}
        onClick={() => setExpanded(prev => !prev)}
      >
        <Stack direction='row' alignItems='center' spacing={1.5}>
          <BlockIcon color='error' />
          <Typography variant='subtitle1' fontWeight={700}>
            Blacklist Globale Nomi File
          </Typography>
          <Chip
            label={blacklist.length}
            size='small'
            color={blacklist.length > 0 ? 'error' : 'default'}
            variant='outlined'
            sx={{ fontWeight: 600 }}
          />
        </Stack>
        <IconButton size='small'>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Stack>

      <Collapse in={expanded}>
        <Typography variant='caption' color='text.secondary' sx={{ mt: 1, mb: 2, display: 'block' }}>
          I file con questi nomi verranno esclusi e ignorati dal processamento e non genereranno alcun log. La blacklist è globale per tutte le configurazioni.
        </Typography>

        <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 2 }}>
          <TextField
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleAdd() }}
            size='small'
            fullWidth
            placeholder='Inserisci nome file (es. report.txt) e premi Invio...'
            sx={{ maxWidth: 500, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
          />
          <Button
            size='small'
            variant='contained'
            color='error'
            disabled={!input.trim()}
            onClick={handleAdd}
            sx={{ textTransform: 'none', fontWeight: 600, minWidth: 100 }}
          >
            Aggiungi
          </Button>
        </Stack>

        {blacklist.length > 0 && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {blacklist.map((item) => (
              <Chip
                key={item._id}
                label={item.fileName}
                onDelete={() => handleRemove(item._id)}
                deleteIcon={
                  <Tooltip title='Rimuovi dalla blacklist' arrow>
                    <DeleteOutlineIcon fontSize='small' />
                  </Tooltip>
                }
                variant='outlined'
                color='error'
                sx={{ fontWeight: 500 }}
              />
            ))}
          </Box>
        )}

        {blacklist.length === 0 && (
          <Typography variant='body2' color='text.secondary' sx={{ fontStyle: 'italic' }}>
            Nessun file in blacklist.
          </Typography>
        )}
      </Collapse>
    </Paper>
  )
}

export default BlacklistSection
